jQuery(document).ready(function($) {

	$('#newsletter-form').submit(e => {
		e.preventDefault();
		data = {
			'first_name': $('input[name=firstname]').val(),
			'last_name': $('input[name=lastname]').val(),
			'organisation': $('input[name=organisation]').val(),
			'email': $('input[name=email]').val(),
			'researcher': $('input[name=researcher]').is(':checked')
		}
		postToMailchimp(data);
	}) 

	function postToMailchimp(data) {
		const api_url = $('#home_url').text() + '/wp-json/deepsouth-api/v1/post-to-mailchip';
		return new Promise((resolve, reject) => {
			$.ajax({
				url: api_url,
				data: JSON.stringify(data),
				dataType: 'json',
				method: 'POST',
				success: function(data) {
					resolve(data);
					$('#newsletter-form input').val('');
					$('#newsletter-form button[type=submit]').addClass('success');
					window.setTimeout(() => {
						$('#newsletter-form button[type=submit]').removeClass('success');
					}, 10000) 
				},
				error: function(error) {
					reject(error);
					console.log(error);
				}
			})
		})	
	}

})